import React, { useState, useEffect } from 'react';
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";
import Loader from '../common/Loader'
import ApiService from "../../services/api.service";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { gridSpacing } from "../../store/constants";
import SchoolFeeCard from "../common/SchoolFeeCard";
import TotalIncomeLightCard from "../common/AdminDashboard/TotalIncomeLightCard";
import TotalGrowthBarCard from "../common/AdminDashboard/TotalGrowthBarCard";
import PopularCard from "../common/AdminDashboard/PopularCard";
import TopBar from '../common/AdminDashboard/TopBar';
import { subCounties } from '../../utils';
import { toTitleCase } from './summary';
import { dateFormatter } from '../../utils';
import { useNavigate } from "react-router-dom";
import { updateDashboardFilters } from '../../store/actions/updateDashboardFilters';
import { useDispatch } from 'react-redux';

const AdminDashboard = ({ navigation }) => {
    const [loader, showLoader] = useState(false);
    const [bal_err, setBalError] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    useEffect(() => () => { window.history.replaceState({}, document.title); }, [])
    const [isLoading, setLoading] = useState(true);
    const [subCountiesData, setSubCountiesData] = useState([]);
    const [subTallyData, setTallyData] = useState([]);
    const getGraphData = () => {
        return new Promise((resolve, reject) => {
            try {
                const payload = {
                    "startDate": dateFormatter(startDate),
                    "endDate": dateFormatter(endDate)
                };
                let uri = "/farmer/subcounties";
                ApiService.post(uri, payload).subscribe((res) => {
                    if (res !== null && res !== undefined && res.data !== undefined && res.data !== null && res.data !=="" ) {
                        var data = subCounties.map(subcounty => {
                            const matchingResult = res?.data?.find(item => item.SUBCOUNTY_NAME === subcounty.SUBCOUNTY_NAME);
                            return matchingResult ? { ...subcounty, TOTAL_AMOUNT: matchingResult.TOTAL_AMOUNT, SUBCOUNTY_NAME: toTitleCase(matchingResult.SUBCOUNTY_NAME)  } : { SUBCOUNTY_NAME: toTitleCase(subcounty.SUBCOUNTY_NAME) , TOTAL_AMOUNT: subcounty.TOTAL_AMOUNT };
                        });
                        showLoader(false);
                        resolve(data);
                    } else {
                        showLoader(false);
                        reject("No data found");
                    }
                });
            } catch (e) {
                showLoader(false);
                reject(e);
            }
        });
    };

    const getTallyData = () => {
        return new Promise((resolve, reject) => {
            try {
                const payload = {
                    "startDate": dateFormatter(startDate),
                    "endDate": dateFormatter(endDate)
                };
                // showLoader(true);
                let uri = "/farmer/program";
                ApiService.post(uri, payload).subscribe((res) => {
                    if (res.data !== undefined && res.data !== null) {
                        showLoader(false);
                        resolve(res.data);
                    } else {
                        showLoader(false);
                        reject("No data found");
                    }
                });
            } catch (e) {
                showLoader(false);
                reject(e);
            }
        });
    };


    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const [graphsData, tallyData] = await Promise.all([getGraphData(), getTallyData()]);
                setSubCountiesData(graphsData);
                setTallyData(tallyData)
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data: --------------->>', error);
                setLoading(false);
            }
        };
        fetchData();
    }, [endDate]);

    const showMore = () => {
        navigate("/service-details")
    }




    useEffect(() => {
        let isMounted = true
        const intervalId = setInterval(() => { 
            const fetchData = async () => {
                try {
                    const [graphsData, tallyData] = await Promise.all([getGraphData(), getTallyData()]);
                    setSubCountiesData(graphsData);
                    setTallyData(tallyData)
                } catch (error) {
                    console.error('Error fetching data: --------------->>', error);
                }
            };
            fetchData();
        }, 10000)
     
        return () => {
            clearInterval(intervalId); //This is important
            isMounted = false // Let's us know the component is no longer mounted.
        }
     
    }, [])
    
    

    return (
        <>
            <div className="home_landing">
                <Header />
                <div className="home_app">
                    <LeftBar />
                    <div className="home_data_template_preset">
                        <div className="verify">
                            <Loader loader={loader} />
                            <div className="verify_wrapper">
                                <Grid container spacing={gridSpacing}>
                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        <TopBar isLoading={isLoading} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
                                    </Grid>
                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        <TotalIncomeLightCard isLoading={isLoading} startDate={dateFormatter(startDate)} endDate={dateFormatter(endDate)} subTallyData={subTallyData} />

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={gridSpacing}>
                                            {
                                                subTallyData.map((value, index) => (
                                                    <Grid key={index} item lg={3} md={6} sm={6} xs={12} onClick={
                                                        () => {
                                                            dispatch(updateDashboardFilters({
                                                                "startDate": dateFormatter(startDate),
                                                                "endDate": dateFormatter(endDate),
                                                                "type": value.TYPE,
                                                                totalSpent: value.TOTAL_AMOUNT
                                                            }))
                                                            navigate("/service-details", {
                                                            state: {
                                                                "startDate": dateFormatter(startDate),
                                                                "endDate": dateFormatter(endDate),
                                                                "type": value.TYPE,
                                                                totalSpent: value.TOTAL_AMOUNT
                                                            }
                                                        })}
                                                    
                                                    } >
                                                            <SchoolFeeCard isLoading={isLoading} border={true} cardData={value} />
                                                    </Grid>
                                                ))}
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={23} alignItems="center">
                                        <Typography color='#000' align='center' sx={{ fontWeight: '700', fontSize: '2rem', fontWeight: 700, mt: 1.75 }}>
                                            Muranga Subsidy Services Spend Over Subcounties
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={gridSpacing}>
                                            <Grid item xs={12} md={8}>
                                                <TotalGrowthBarCard isLoading={isLoading} subCountiesData={subCountiesData} />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <PopularCard isLoading={isLoading} subCountiesData={subCountiesData} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default AdminDashboard;

